"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useInterval = function (duration) {
    var interval = (0, react_1.useRef)(null);
    var start = function (callback) {
        cancel();
        interval.current = setInterval(callback, duration);
    };
    var cancel = function () {
        interval.current && clearInterval(interval.current);
        interval.current = null;
    };
    (0, react_1.useEffect)(function () {
        return function () { return cancel(); };
    }, []);
    return {
        start: start,
        cancel: cancel,
    };
};
exports.default = useInterval;
